import React from "react";
import PropTypes from "prop-types";
import { CustomButton } from "./ButtonStyles.js";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Button = ({ type, label, clickHandler, className,text }) => {
  return (
    <CopyToClipboard text={text}>
    <CustomButton
      className={className}
      as="button"
      onClick={clickHandler}
      type={type}
    >
      {label}
    </CustomButton>
     </CopyToClipboard>
  );
};

Button.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
};
Button.defaultProps = {
  type: "primary",
  label: "test button",
  clickHandler: () => {
    return true;
  },
};

export default Button;
